export default import.meta.ROLLDOWN_FILE_URL_pOXOLHH9EmP_EUmAXFH0nQ